<ngx-page-container>
  <h1>Navigation</h1>
  <hr>

  <div class="container">
    <div class="column">
      <div *ngIf="access('core') || access('products')" class="h3">Products</div>
      <ul>
        <li *ngIf="access('core')"><button class="button" [routerLink]="['/pages/erp/core']">Cores</button></li>
        <li *ngIf="access('materials') || access('productswrite')"><button class="button" [routerLink]="['/pages/erp/material']">Materials</button></li>
        <li *ngIf="access('products')"><button class="button" [routerLink]="['/pages/erp/base-product']">Base products</button></li>
        <li *ngIf="access('products')"><button class="button" [routerLink]="['/pages/erp/finished-product']">Finished products</button></li>
      </ul>
      <ng-container *ngFor="let i of ['nrka', 'nrkg']">
        <ng-container *ngIf="access(i)">
          <br>
          <div class="h3">Price matrix {{i | uppercase}}</div>
          <ul>
            <li><button class="button" [routerLink]="['/pages/erp/price-matrix/' + i + '/finished-product']">Price matrix: Finished product</button></li>
            <li><button class="button" [routerLink]="['/pages/erp/price-matrix/' + i + '/selling']">Price matrix: Selling</button></li>
            <li><button class="button" [routerLink]="['/pages/erp/price-matrix/' + i + '/buying']">Price matrix: Buying</button></li>
            <li><button class="button" [routerLink]="['/pages/erp/price-matrix/' + i + '/comparison']">Price matrix: Comparison</button></li>
          </ul>
        </ng-container>
      </ng-container>
    </div>
    <ng-container *ngFor="let i of ['nrka', 'nrkg']">
      <div class="column" *ngIf="access(i)">
        <div class="h3">Documents {{i | uppercase}}</div>
        <ul>
          <!-- <li><button class="button" [routerLink]="['/pages/erp/document/' + i]" [queryParams]="{doctype: 'OF'}">Offers</button></li>
          <li><button class="button" [routerLink]="['/pages/erp/document/' + i]" [queryParams]="{doctype: 'OR'}">Orders</button></li>
          <li><button class="button" [routerLink]="['/pages/erp/document/' + i]" [queryParams]="{doctype: 'OC'}">Order confirmations</button></li>
          <li><button class="button" [routerLink]="['/pages/erp/document/' + i]" [queryParams]="{doctype: 'PL'}">Packing lists</button></li>
          <li><button class="button" [routerLink]="['/pages/erp/document/' + i]" [queryParams]="{doctype: 'SPO'}">Supplier purchase orders</button></li>
          <li><button class="button" [routerLink]="['/pages/erp/document/' + i]" [queryParams]="{doctype: 'IN'}">Invoices</button></li>
          <li><button class="button" [routerLink]="['/pages/erp/document/' + i]" [queryParams]="{doctype: 'DN'}">Delivery notes</button></li>
          <li><button class="button" [routerLink]="['/pages/erp/document/' + i]" [queryParams]="{doctype: 'PFSPO'}">Proforma supplier purchase orders</button></li>
          <li><button class="button" [routerLink]="['/pages/erp/document/' + i]" [queryParams]="{doctype: 'PFSPC'}">Proforma chain transaction SPO</button></li>
          <li><button class="button" [routerLink]="['/pages/erp/document/' + i]" [queryParams]="{doctype: 'PFIN'}">Proforma invoice</button></li>
          <li><button class="button" [routerLink]="['/pages/erp/document/' + i]" [queryParams]="{doctype: 'CN'}">Credit note</button></li>
          <li><button class="button" [routerLink]="['/pages/erp/document/' + i]" [queryParams]="{doctype: 'PFCN'}">Proforma credit note</button></li> -->
          <li *ngFor="let type of docTypes.getTypes()">
            <button class="button" [routerLink]="['/pages/erp/document/' + i]" 
              [queryParams]="{doctype: type.code}">{{type.name}}
            </button>
          </li>
          <li><button class="button" [routerLink]="['/pages/erp/offers']" [queryParams]="">Offers NRKA & NRKG</button></li>
        </ul>
      </div>
    </ng-container>
    <div class="column" *ngIf="access('reports')">
      <div class="h3">Reports</div>
      <ul>
        <li><button class="button" [routerLink]="['/pages/erp/reports']" [queryParams]="{id: 'OF'}">Offers</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/reports']" [queryParams]="{id: 'FCOR'}">Frame contracts</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/reports']" [queryParams]="{id: 'OR'}">Orders</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/reports']" [queryParams]="{id: 'NIOC'}">Non invoiced OCs</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/reports']" [queryParams]="{id: 'OSPO'}">Open (PF)SPOs</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/reports']" [queryParams]="{id: 'ILI'}">Invoiced line items</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/reports']" [queryParams]="{id: 'OOR'}">Open orders</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/reports']" [queryParams]="{id: 'PM'}">Pricing matix</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/reports']" [queryParams]="{id: 'DI'}">Due invoices</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/reports']" [queryParams]="{id: 'ILW'}">Invoices of last week</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/reports']" [queryParams]="{id: 'CO'}">Business overview</button></li>
      </ul>
    </div>

    <div class="column" *ngIf="access('utilities')">
      <div class="h3">Utilities</div>
      <ul>
        <li><button class="button" [routerLink]="['/pages/erp/utilities/checklist']">Checklist editor</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/utilities/changelog']">Changelog text editor</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/utilities/fileDescriptions']">File descriptions</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/utilities/currency']">Currency editor</button></li>
        <li><button class="button" [routerLink]="['/pages/erp/utilities/legacyData']">Legacy data editor</button></li>
      </ul>
    </div>

  </div>

</ngx-page-container>

